// eslint-disable-next-line import/no-cycle
import { SessionInformation } from '../app/SessionProvider';

export const sessionStateMock: SessionInformation = {
  setCustomSessionIdleTime: () => null,

  start: () => null,
  reset: () => null,
  pause: () => null,
  resume: () => null,

  isIdle: () => false,
  isLeader: () => false,

  getRemainingTime: () => 0,
  getElapsedTime: () => 0,
  getLastIdleTime: () => 0,
  getLastActiveTime: () => 0,
  getTotalIdleTime: () => 0,
  getTotalActiveTime: () => 0,
};
